export default __webpack_public_path__ + "assets/images/0c101ab143cb8f9ef6c38c69c681b45f.png";